import { Schema, model, Types, models, Model, ObjectId } from "mongoose";
import { stringifyFields } from "based-shared/utils/stringify-fields";

// Transaction Types
export interface ITransaction extends Document {
  id: string;
  _id?: ObjectId;
  __v?: number;
  chainId: number;
  address: string;
  account: string;
  referrer: string;
  time: Date;
  currentPrice: Schema.Types.Decimal128;
  isBought: boolean;
  signature: string;
  decimals: number;
  reserveETH: Schema.Types.Decimal128;
  reserveToken: Schema.Types.Decimal128;
  amountETH: Schema.Types.Decimal128;
  amountToken: Schema.Types.Decimal128;
  amountOwnerFee: Schema.Types.Decimal128;
  amountSubBoardFee: Schema.Types.Decimal128;
  amountTokenOwnerFee: Schema.Types.Decimal128;
  amountReferralFee: Schema.Types.Decimal128;
}

const transactionSchema = new Schema<ITransaction>(
  {
    chainId: { type: Number, required: true },
    address: { type: String, required: true },
    account: { type: String, required: true },
    referrer: { type: String, default: "" },
    time: {
      type: Date,
      required: true,
    },
    currentPrice: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    isBought: {
      type: Boolean,
      default: true,
    },
    signature: {
      type: String,
      required: true,
    },
    decimals: {
      type: Number,
      required: true,
      set: (value: string) => Number(value),
    },
    reserveETH: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    reserveToken: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountETH: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountToken: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountOwnerFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountSubBoardFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountTokenOwnerFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    amountReferralFee: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: ITransaction) => {
        if (ret._id) {
          ret.id = ret._id.toString();
          delete ret._id;
        }
        delete ret.__v;

        return stringifyFields(ret);
      },
    },
  }
);

transactionSchema.index(
  {
    referrer: 1,
    signature: 1,
  },
  { unique: true }
);

transactionSchema.index(
  {
    chainId: 1,
    address: 1,
    account: 1,
    time: 1,
  },
  { unique: true }
);

export const TransactionModel: Model<ITransaction> =
  models?.Transaction || model<ITransaction>("Transaction", transactionSchema);
